export default {"src":"/_next/static/media/dollar-sign.5d53c1b5.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};